import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useRef } from 'react';
import { LegacyDevice } from 'console/device/device';
import { ThermostatCard } from './cards/TermostatCard';
import { OpenThermCardLastBoilerState, OTCardsLastBoilerState, } from './cards/OpenThermCardLastBoilerState';
import { WifiCard } from './cards/Wifi-Card';
import { ThermometersCard } from './cards/ThermometersCard';
import { BoilerFailPane } from './boiler-fail-pane';
import { Capability } from 'console/device/device-capability';
import * as classnames from 'classnames';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import memoizeOne from 'memoize-one';
import { PowerCard } from './cards/power-card';
import { NetworkCard } from './cards/gsm/GSM-card';
import { useGetSimInDevice } from 'console/sim/utils/select-sim';
import { useBilledSimState } from 'console/sim/utils/status';
import { selectSelectedDevice } from 'entities/device/lib';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { DevicePermission } from 'console/device/device_ts';
import { CustomControlCard } from 'console/tabs/legacy/state/components/cards/custom-control-card';
import { GuardCard } from 'console/tabs/legacy/guard-card';
const _is_phone_screen = () => Math.min(screen.width, screen.height) <= 480;
const is_phone_screen = memoizeOne(_is_phone_screen);
function useNetworkHasIssues(device_id) {
    const [billed_sim] = useGetSimInDevice(device_id);
    const [, billed_sim_state] = useBilledSimState(billed_sim?.sim_card.id.id, billed_sim?.sim_card.id.operator);
    return ENABLE_SIM ? billed_sim_state?.status != 'ok' : false;
}
export const StateTabContents = memo(function StateTabContents(props) {
    const { active } = props;
    const [showDetails, , , toggleDetails] = useBooleanState(false);
    const show_details_button_ref = useRef(null);
    const container_ref = useRef(null);
    const r_device = useAppSelector(selectSelectedDevice);
    const account = useAppSelector((state) => state.account);
    const server_time = useAppSelector((state) => state.server_time);
    const network_has_issues = useNetworkHasIssues(r_device?.id ?? -1);
    if (!r_device) {
        return null;
    }
    const show_details_button = LegacyDevice.has_capability(r_device?.capabilities, Capability.has_car_sensors) && is_phone_screen();
    const show_details = !show_details_button || showDetails;
    const network_card = (_jsx(NetworkCard, { account: account, r_device: r_device }, "NetworkCard"));
    const standard_cards = [
        network_has_issues && network_card,
        _jsx(CustomControlCard, { device_id: r_device.id, capabilities: r_device.capabilities, custom_controls: r_device.custom_controls, can_control: LegacyDevice.has_access(account.id, r_device, DevicePermission.control) && !account.is_guest }, "CustomControlsCard"),
        _jsx(GuardCard, { account: account, r_device: r_device, server_time: server_time, active: active }, "GuardCard"),
        _jsx(ThermostatCard, { r_device: r_device }, "ThermostatCard"),
        r_device.ot_enabled && r_device.last_boiler_state?.ot != null && (_jsx(OpenThermCardLastBoilerState, { device_id: r_device.id, ot: r_device.last_boiler_state?.ot }, "OpenThermCard")),
        r_device.ot_enabled && (_jsx(OTCardsLastBoilerState, { ot_zones_count: r_device?.ot_zones_count, otzones_last: r_device?.otzones_last, id: r_device.id }, "OpenThermCard_old")),
        show_details_button && (_jsx("div", { ref: show_details_button_ref, className: classnames('ui-state-tab-show-details-button', {
                'details-shown': show_details,
            }), onClick: toggleDetails, children: show_details ? 'СКРЫТЬ ПОДРОБНОСТИ' : 'ПОДРОБНЕЕ' }, "show-details-button")),
        show_details && _jsx(PowerCard, { r_device: r_device }, "PowerCard"),
        show_details && !network_has_issues && network_card,
        _jsx(WifiCard, { r_device: r_device }, "WifiCard"),
        _jsx(ThermometersCard, { server_time: server_time, r_device: r_device }, "ThermometersCard"),
    ];
    return (_jsxs("div", { className: classnames('ui-falarm-main-view', 'ui-fixed-alarm-tab'), ref: container_ref, children: [_jsx("div", { className: 'ui-cards-container', children: _jsx(BoilerFailPane, { fail: r_device.last_boiler_state?.fail || false, single_ot: r_device.last_boiler_state?.ot, multi_ot: r_device.otzones_last, ot_zones_count: r_device.ot_zones_count, ot_boiler_type: r_device.ot_boiler_type }) }), _jsx("div", { className: classnames('ui-cards-container', 'ui-falarm-main-view-content'), children: standard_cards })] }));
});
